import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { StorageMap } from '@ngx-pwa/local-storage';
import { map, switchMap } from 'rxjs/operators';
import { UserService } from './user.service';
import { MDBModalRef, MDBModalService } from 'ng-uikit-pro-standard';
import { ChangePasswordDialogComponent } from '../../views/dialog/change-password-dialog/change-password-dialog.component';
import { of } from 'rxjs';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';

@Injectable({
  providedIn: 'root'
})
export class AuthGaurd implements CanActivate {
  modalRef: MDBModalRef;
  constructor(
    private router: Router,
    private authServ: AuthService,
    private userServ: UserService,
    private modalService: MDBModalService,
    private storage: StorageMap,
    private ps: NgxPermissionsService,
    private rs: NgxRolesService
  ) { }

//   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
//     // ดักจับ token จาก URL สำหรับ ThaiID
//     const token = route.queryParams['token'];
//     const refreshToken = route.queryParams['refresh_token'];
    
//     if (token && refreshToken) {
//       return this.processThaiIdLogin(token, refreshToken);
//     }
    
//     // ถ้าเป็น root path และไม่มี token
//     if ((state.url === '/' || state.url === '') && !token) {
//       return this.storage.get('token').pipe(
//         switchMap(storageToken => {
//           if (!storageToken) {
//             this.router.navigate(['/sessions/signinv2']);
//             return of(false);
//           }
//           // มี token ให้ไปต่อ
//           return this.authServ.isAuthorized().pipe(map(res => {
//             if (res) {
//               // logic first time login
//               // var curresntUser = this.userServ.curtrentUser;
//               // if (curresntUser != null && curresntUser.is_firsttime == 1) {
//               //   this.modalRef = this.modalService.show(ChangePasswordDialogComponent, {
//               //     width: '850px',
//               //     backdrop: true,
//               //     keyboard: true,
//               //     focus: true,
//               //     show: false,
//               //     ignoreBackdropClick: true,
//               //     class: 'modal-lg modal-notify modal-warning modal-dialog-centered',
//               //     containerClass: '',
//               //     animated: true,
//               //   });
//               // }
//               return true;
//             }
//             this.router.navigate(['/sessions/signinv2']);
//             return false;
//           }));
//         })
//       );
//     }
    
//     // Logic เดิมสำหรับ path อื่นๆ
//     return this.authServ.isAuthorized().pipe(map(res => {
//       if (res) {
//         // var curresntUser = this.userServ.curtrentUser;
//         // if (curresntUser != null && curresntUser.is_firsttime == 1) {
//         //   this.modalRef = this.modalService.show(ChangePasswordDialogComponent, {
//         //     width: '850px',
//         //     backdrop: true,
//         //     keyboard: true,
//         //     focus: true,
//         //     show: false,
//         //     ignoreBackdropClick: true,
//         //     class: 'modal-lg modal-notify modal-warning modal-dialog-centered',
//         //     containerClass: '',
//         //     animated: true,
//         //   });
//         // }
//         return true;
//       } else {
//         this.storage.clear().subscribe(() => {
//           this.router.navigate(['/sessions/signinv2']);
//         });
//         return false;
//       }
//     }));
//   }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // ถ้าเป็นหน้า signin ให้ผ่านไปเลย
    if (state.url.includes('/sessions/signinv2')) {
      return of(true);
    }
    
    // ตรวจสอบ URL params สำหรับ ThaiID callback
    // const urlParams = new URLSearchParams(window.location.search);
    // const error = urlParams.get('error');
    // const token = urlParams.get('token');
    // const refreshToken = urlParams.get('refresh_token');
    
    // // ถ้ามี ThaiID params ให้ redirect ไป signin page
    // if (error || token || refreshToken) {
    //   this.router.navigate(['/sessions/signinv2'], { 
    //     queryParams: route.queryParams,
    //     replaceUrl: true
    //   });
    //   return of(false);
    // }
    
    // Logic การตรวจสอบ auth ปกติ
    return this.storage.get('token').pipe(
      switchMap(storageToken => {
        if (!storageToken) {
          this.router.navigate(['/sessions/signinv2']);
          return of(false);
        }
        return this.authServ.isAuthorized().pipe(
          switchMap(res => {
            if (res) {
              return this.storage.get('user').pipe(
                switchMap(userData => {
                  if (!userData) {
                    return this.userServ.getUserInfo().pipe(
                      switchMap(() => this.userServ.loadLogin()),
                      switchMap((loginData: any) => {
                        if (loginData) {
                          this.ps.loadPermissions(loginData.perm);
                          this.rs.addRole(loginData.name, loginData.perm);
                          return this.storage.set('user', loginData).pipe(map(() => true));
                        }
                        this.router.navigate(['/sessions/signinv2']);
                        return of(false);
                      })
                    );
                  }
                  return of(true);
                })
              );
            }
            this.router.navigate(['/sessions/signinv2']);
            return of(false);
          })
        );
      })
    );
  }
}